export default __webpack_public_path__ + "static/media/observing-bacteria.0f125f50.jpg";